define('model/disclosure.comment.model',['require','exports','module','backbone.radio','./base.workflow.model'],function(require, exports, module) {
  //prettier-ignore
  var Radio             = require('backbone.radio'),
      BaseWorkflowModel = require('./base.workflow.model'),

      //Radio channels
      UIChannel = Radio.channel('UIChannel');

  var DisclosureCommentModel = BaseWorkflowModel.extend({
    radioRequests: {
      'models DisclosureCommentModel': '@constructor',
    },

    initialize: function() {
      BaseWorkflowModel.prototype.initialize.apply(this, arguments);

      this.on('error', function() {
        UIChannel.request('proposal:ui:reset');
      })
    },
  });

  module.exports = DisclosureCommentModel;
});

